<ng-content select="[image]"></ng-content>
<div mat-dialog-title>
  <h2>{{ data.title | locale }}</h2>
  @if (data.icon) {
    <mat-icon class="icon" [svgIcon]="data.icon"></mat-icon>
  }
</div>
<mat-dialog-content>
  @if (data.message) {
    <p>{{ data.message | locale }}</p>
  }
  @if (data.messages) {
    @for (message of data.messages; track message) {
      <p>{{ message | locale }}</p>
    }
  }

  @if (data.inputType) {
    @switch (data.inputType) {
      @case (InputTypes.TEXT) {
        <mat-form-field appearance="outline" class="outline">
          <input matInput type="text" [(ngModel)]="value" />
        </mat-form-field>
      }
    }
  }
</mat-dialog-content>
@if (data.canCancel || data.actions?.length > 0) {
  <mat-dialog-actions>
    @if (data.canCancel) {
      <button color="primary" mat-stroked-button (click)="cancel()">
        {{ data.closeMessage ? (data.closeMessage | locale) : ('dialog_close' | locale) }}
      </button>
    }
    @for (button of data.actions; track button) {
      <button color="primary" mat-flat-button cdkFocusInitial (click)="execute(button.action)">
        {{ button.message || 'dialog_accept' | locale }}
        <ng-content select="[icon]"></ng-content>
      </button>
    }
  </mat-dialog-actions>
}
